import { useState } from 'react';
import { GuestProfile } from '@mews-commander/guest-profile';
import { useDialog } from '@mews/framework';

export const useGuestDetailDialog = (matchingProfiles: Array<GuestProfile>) => {
    const [dialogProps, toggleOpenDialog] = useDialog();
    const [selectedGuestId, setSelectedGuestId] = useState<string | null>(null);

    const handleClose = () => {
        dialogProps.onClose();
        setSelectedGuestId(null);
    };

    const handleOpen = (guestId: string) => {
        const matchingProfileId = matchingProfiles.find((profile) => profile.id === guestId)?.id;
        setSelectedGuestId(matchingProfileId ?? null);
        toggleOpenDialog();
    };

    const selectedGuestFullName = matchingProfiles.find(({ id }) => id === selectedGuestId)?.fullName;

    return {
        guestDetailDialogProps: { opened: dialogProps.active, onClose: handleClose },
        handleOpenGuestDetailDialog: handleOpen,
        selectedGuestId,
        selectedGuestFullName,
    };
};
